import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
//Material imports
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandIcon from "@material-ui/icons/ExpandMore";
import CollapseIcon from "@material-ui/icons/ExpandLess"; //Limitless imports

import HeaderIconButton from "../../../portal/components/buttons/header-icon-button/HeaderIconButton"; // import { HeaderIconButton } from "portal";

import { useDialogueBodyStyles } from "./DialogueBody";
var useStyles = makeStyles({
  clamp: {
    display: "-webkit-box",
    lineClamp: 10,
    boxOrient: "vertical"
  },
  clampButton: {
    position: "absolute",
    right: 0,
    bottom: -5,
    padding: 0
  }
});

var ClampedDialogueBody = function ClampedDialogueBody(_ref) {
  var body = _ref.body,
      textStyling = _ref.textStyling,
      index = _ref.index;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      clamped = _React$useState2[0],
      setClamped = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      textHeight = _React$useState4[0],
      setTextHeight = _React$useState4[1];

  var textRef = React.useRef(null);
  var bodyClasses = useDialogueBodyStyles();
  var classes = useStyles();
  React.useEffect(function () {
    setTextHeight(textRef.current.offsetHeight);
  }, [textRef]);
  var rootClass = textStyling;
  var shouldClamp = textHeight > 200 ? true : false;

  if (shouldClamp && clamped) {
    rootClass = "".concat(textStyling, " ").concat(classes.clamp);
  }

  var onDialogueClick = React.useCallback(function () {
    setClamped(!clamped);
  });
  var ClampIcon = clamped ? ExpandIcon : CollapseIcon;
  return /*#__PURE__*/React.createElement(Typography, {
    ref: textRef,
    classes: {
      root: rootClass
    },
    component: "div",
    tabIndex: "0",
    className: bodyClasses.dialogueBody
  }, body, shouldClamp && /*#__PURE__*/React.createElement(HeaderIconButton, {
    onButtonClick: onDialogueClick,
    tooltip: clamped ? "See More" : "See Less",
    buttonId: "toggleDialogueSizeButton".concat(index),
    icon: /*#__PURE__*/React.createElement(ClampIcon, {
      style: {
        fontSize: 32
      },
      color: "secondary"
    }),
    buttonClass: classes.clampButton
  }));
};

export default ClampedDialogueBody;